import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { ExchangeCountState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/exchange-count";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { memo } from "react";

export const ExchangeCountDetails = memo(function ExchangeCountDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<ExchangeCountState>) {
  return (
    <RedoTextInput
      description="Applies to each returned item. 1 = items can be exchanged once, 2 = items can be exchanged twice. All returned items must qualify."
      inputTypeHint="number"
      label="Allowed # exchanges per item"
      min={1}
      onBlur={() => setState((+state).toFixed(0))}
      setValue={(e) => setState(e)}
      size="sm"
      state={disabled ? "disabled" : "default"}
      value={state}
    />
  );
});
